import React, {
	useRef,
	useEffect,
	useState,
	useContext,
	memo,
	forwardRef,
} from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import HTMLFlipBook from "react-pageflip";
import "./bookPreview.styles.css";
import frontCover from "../../assets/images/bookPreviewImages/FrontCover.jpg";
import backCover from "../../assets/images/bookPreviewImages/ebook_back_cover.jpg";
import SmallLogo from "../../assets/images/dark-logo.png";
import speaker from "../../assets/images/volume.png";
import mute from "../../assets/images/mute.png";
import play from "../../assets/images/play.png";
import pause from "../../assets/images/pause.png";
import axios from "axios";
import Swal from "sweetalert2";
import { AppContext } from "../../context/AppContext";
import AnimationSpinner from "../../AnimationSpinner";
import avatarVideoStatic from "../../assets/video/custom_avatar_page_video_v2.mp4";
import {
	AiOutlinePause,
	AiOutlinePlayCircle,
	AiOutlineStop,
} from "react-icons/ai";
import { BsFillVolumeUpFill } from "react-icons/bs";
import ErrorComponent from "../NoDataFound.jsx/NoError.jsx";
import EmptyIcon from "../../assets/images/book-preview.jpg";
// react icons import
import {
	FaArrowDown,
	FaArrowLeft,
	FaArrowRight,
	FaShareSquare,
	FaFacebook,
	FaTwitter,
	FaWhatsapp,
	FaLinkedin,
	FaTelegram,
	FaFacebookMessenger,
	FaReddit,
	FaEnvelope,
	FaGetPocket,
	FaTumblr,
	FaBlogger,
} from "react-icons/fa";
import { BsFillPlayBtnFill, BsArrowsFullscreen } from "react-icons/bs";
import { GrZoomIn, GrZoomOut, GrPowerReset } from "react-icons/gr";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";

import { chunkArray } from "../../util.js";
import IndexTemplate from "../../components/custom-components/BookFlow/indexComponent/IndexTemplate.jsx";
import { number } from "yup";
import { GiSpeakerOff } from "react-icons/gi";
import { toast } from "react-toastify";

const FrontPage = memo(
	forwardRef(({ coverImage }, ref) => (
		<div className="page page-cover" ref={ref} data-density="hard">
			<div className="page-content" style={{ position: "relative" }}>
				<img
					src={coverImage}
					alt="Book Cover"
					style={{
						width: "100%",
						height: "100%",
						objectFit: "contain",
						backgroundColor: "black",
					}}
				/>
			</div>
		</div>
	)),
	(prevProps, nextProps) => prevProps.coverImage === nextProps.coverImage
);

const Page = memo(
	forwardRef(
		(
			{
				title,
				number,
				children,
				isLeftPage, // New prop to identify left pages
			},
			ref
		) => {
			return (
				<div className="page" ref={ref}>
					{/* Show title on first page of a chapter OR left pages */}
					{(number == 1 || (number == 2 && isLeftPage)) && <h5>{title}</h5>}

					<div dangerouslySetInnerHTML={{ __html: children }} />
				</div>
			);
		}
	),
	(prevProps, nextProps) =>
		prevProps.title === nextProps.title &&
		prevProps.children === nextProps.children
);

const TalkingBookPreview = () => {
	const flipBookRef = useRef(null);
	const videoRef = useRef(null);

	// book data
	const [fetchedBookData, setFetchedBookData] = useState({});
	const [dataFetched, setDataFetched] = useState(false);
	// for index page
	const [indexPage, setIndexPage] = useState("");
	const [newIndexItems, setNewIndexItems] = useState([]);

	// for book pages
	const [bookChapter, setBookChapters] = useState([]);
	const [bookPages, setBookPages] = useState([]);

	// speech
	const [speechEnabled, setSpeechEnabled] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);
	const [avatarImage, setAvatarImage] = useState(null);
	const [avatarVideo, setAvatarVideo] = useState(null);

	const [speechClicked, setSpeechClicked] = useState(false);

	const [currentPage, setCurrentPage] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const [paginatedContent, setPaginatedContent] = useState([]);
	const [paginatedIndexPages, setPaginatedIndexPages] = useState([]);
	const hiddenDivRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const [activeSpeechAudio, setActiveSpeechAudio] = useState("");
	const { base_url } = useContext(AppContext);
	const { slug } = useParams();
	const audioRef = useRef(null);

	const [activeSpeechType, setActiveSpeechType] = useState(null);
	const currentRenderedPage = useRef(-1);
	const [bookPreview, setBookPreview] = useState(false);

	//model states
	const [modalActive, setModalActive] = useState(false);
	const modalRef = useRef(null);

	var shareBookURL = `${window.location.origin}/talking-book/${slug}`;

	const socialPlatforms = [
		{
			name: "Facebook",
			icon: <FaFacebook />,
			color: "#1877F2",
			link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Twitter",
			icon: <FaTwitter />,
			color: "#1DA1F2",
			link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "WhatsApp",
			icon: <FaWhatsapp />,
			color: "#25D366",
			link: `https://api.whatsapp.com/send?text=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "LinkedIn",
			icon: <FaLinkedin />,
			color: "#0A66C2",
			link: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Telegram",
			icon: <FaTelegram />,
			color: "#26A5E4",
			link: `https://t.me/share/url?url=${encodeURIComponent(shareBookURL)}`,
		},
		{
			name: "Messenger",
			icon: <FaFacebookMessenger />,
			color: "#0084FF",
			link: `https://www.facebook.com/dialog/send?link=${encodeURIComponent(
				shareBookURL
			)}&app_id=YOUR_APP_ID&redirect_uri=${encodeURIComponent(
				window.location.origin
			)}`,
		},
		{
			name: "Reddit",
			icon: <FaReddit />,
			color: "#FF4500",
			link: `https://www.reddit.com/submit?url=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Gmail",
			icon: <FaEnvelope />,
			color: "#EA4335",
			link: `mailto:?subject=Check this out&body=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Pocket",
			icon: <FaGetPocket />,
			color: "#EF3F56",
			link: `https://getpocket.com/edit?url=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Tumblr",
			icon: <FaTumblr />,
			color: "#36465D",
			link: `https://www.tumblr.com/share/link?url=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Blogger",
			icon: <FaBlogger />,
			color: "#FF8000",
			link: `https://www.blogger.com/blog-this.g?u=${encodeURIComponent(
				shareBookURL
			)}`,
		},
		{
			name: "Outlook",
			icon: <FaEnvelope />,
			color: "#0078D4",
			link: `mailto:?subject=Check this out&body=${encodeURIComponent(
				shareBookURL
			)}`,
		},
	];

	const modalVariants = {
		hidden: { opacity: 0, scale: 0.9 },
		visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
		exit: { opacity: 0, scale: 0.9, transition: { duration: 0.4 } },
	};
	const handleModelCloseClick = (event) => {
		if (event.target.classList.contains("history-image-model")) {
			closeModal();
		}
	};
	const closeModal = () => {
		setModalActive(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (modalRef.current && !modalRef.current.contains(event.target)) {
				closeModal();
			}
		};

		if (modalActive) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [modalActive]);

	const handleShare = (link) => {
		if (link) {
			window.open(link, "_blank");
		}
	};

	//   modal functions end

	const toggleNav = () => {
		setIsOpen((prev) => !prev);
	};

	const fetchPageData = async () => {
		try {
			setLoading(true);
			setDataFetched(false);
			const formData = new FormData();
			formData.append("book_token", slug);
			const { data } = await axios.post(`${base_url}bookflow/viewer`, formData);
			if (data.status) {
				setIndexPage(data.res.index_page);
				setBookChapters(data.res.bookContent);
				setFetchedBookData(data.res.book);
				// setBookPages(data.res.bookContentPages.flatMap((page) => [page, page]));
				setBookPages(
					data.res.bookContentPages.flatMap((page, index, array) =>
						index === array.length - 1
							? [{ ...page, isLeftPage: false }]
							: [
								{ ...page, isLeftPage: false },
								{ ...page, isLeftPage: true },
							]
					)
				);
				if ('avatar' in data.res) {
					if ("image" in data.res.avatar) {
						const avatarImageUrl = data.res.avatar.image.startsWith("http")
							? data.res.avatar.image
							: base_url + data.res.avatar.image;
						setAvatarImage(avatarImageUrl);
					}
					if ('video' in data.res.avatar) {
						setAvatarVideo(data.res.avatar.video);
					}
				}
				setDataFetched(true);
				setBookPreview(true);
			} else {
				setBookPreview(false);
				toast.warning(data.message);
			}
		} catch (error) {
			toast.error(
				error.response?.data?.message ||
				error.message ||
				"Something went wrong. Please try again."
			);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		fetchPageData();
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (flipBookRef.current && flipBookRef.current.pageFlip()) {
				const pageCount = flipBookRef.current.pageFlip().getPageCount();
				setTotalPages(pageCount);
			}
		}, 200);
		return () => clearTimeout(timer);
	}, [paginatedContent]);

	window.addEventListener("click", (e) => {
		setSpeechClicked(false);
	});

	const handleFlip = (e) => {
		setCurrentPage(e.data);
		const flippedPage = e.data;
		if (newIndexItems.length % 2 === 0) {
			currentRenderedPage.current = flippedPage - newIndexItems.length;
		} else {
			currentRenderedPage.current = flippedPage - newIndexItems.length;
		}
	};

	const goNext = () => {
		if (flipBookRef.current && flipBookRef.current.pageFlip()) {
			flipBookRef.current.pageFlip().flipNext();
		}
	};

	const goPrev = () => {
		if (flipBookRef.current && flipBookRef.current.pageFlip()) {
			flipBookRef.current.pageFlip().flipPrev();
		}
	};

	useEffect(() => {
		setNewIndexItems(chunkArray(bookChapter, Number(indexPage.page_limit)));
	}, [bookChapter]);

	const handleSpeechClick = (e, type) => {
		e.preventDefault();
		e.stopPropagation();
		const enableAvatar = Number(fetchedBookData.enable_avatar) == 1;
		if (type === "start_speech") {
            let newCurrentPage = currentPage;
            // Fix for single and multiple chapters
            if (newIndexItems.length > 0) {
                if (newIndexItems.length % 2 === 0) {
                    newCurrentPage = currentPage - newIndexItems.length - 1;
                } else {
                    newCurrentPage = currentPage - newIndexItems.length;
                }
            }
            
			const currentRightPage = bookPages[newCurrentPage];
			if (
				!currentRightPage ||
				Number(currentRightPage.status) !== 1 ||
				!currentRightPage.audio_file
			) {
				toast.error("Audio is in processing. Please wait.");
				return;
			}
			const isAudioAvailable = currentRightPage.audio_file !== null || currentRightPage.audio_file !== undefined || currentPage.audio_file !== "";
			if (isAudioAvailable) {
				setActiveSpeechAudio(currentRightPage.audio_file);
				audioRef.current.src = currentRightPage.audio_file;
				setActiveSpeechType(type);
				setSpeechEnabled(true);
				//we are playing audio through useEffect and also setting src there
			}

			setIsPlaying(true);
			if (enableAvatar && avatarVideo !== "") handlePlay();
		} else if (type === "stop_speech") {

			if (audioRef.current) {
				audioRef.current.pause();
				audioRef.current.currentTime = 0;
			}
			setSpeechEnabled(false);
			setIsPlaying(false);
			if (enableAvatar) handleStop();
		} else if (type === "pause_speech") {
			
			if (audioRef.current) {
				audioRef.current.pause();
				setIsPlaying(false);
			}
			if (enableAvatar) handlePause();
		} else if (type === "resume_speech") {
		
			audioRef.current.play()
			setIsPlaying(true);
			if (enableAvatar) handleResume();
		}
		setSpeechClicked(true);
	};

	useEffect(() => {
		if (audioRef.current && activeSpeechAudio) {
			const audio = audioRef.current;
			audio.src = activeSpeechAudio;
			audio.load();

			audio.onloadedmetadata = () => {
				if (activeSpeechType === "start_speech") {
					console.log("audio loaded metadata");
					audio.play()
					setIsPlaying(true);
				}
			};
			audio.onended = () => {
				console.log("audio ended");
				setIsPlaying(false);
				setSpeechEnabled(false);
				if (videoRef.current) {
					videoRef.current.pause();
					videoRef.current.currentTime = 0;
				}
			};
		}
	}, [activeSpeechAudio, activeSpeechType]);

	// const handlePlay = () => {
	// 	if (videoRef.current) {
	// 		videoRef.current.muted = true;
	// 		videoRef.current.play();
	// 	}
	// };

	// const handlePause = () => {
	// 	if (videoRef.current) {
	// 		videoRef.current.pause();
	// 	}
	// };

	// const handleStop = () => {
	// 	if (videoRef.current) {
	// 		videoRef.current.pause();
	// 		videoRef.current.currentTime = 0;
	// 	}
	// };

	// const handleResume = () => {
	// 	if (videoRef.current && videoRef.current.paused) {
	// 		videoRef.current.play();
	// 		videoRef.current.muted = true;
	// 	}
	// };


// Video Control Functions
const handlePlay = () => {
    if (videoRef.current) {
        // videoRef.current.muted = true;
        videoRef.current.play()
    }
};

const handlePause = () => {
    if (videoRef.current) {
        videoRef.current.pause();
    }
};

const handleStop = () => {
    if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
    }
};

const handleResume = () => {
    if (videoRef.current && videoRef.current.paused) {
        videoRef.current.play()
        videoRef.current.muted = true;
    }
};


	// useEffect(() => {
	// 	const audioElement = document.getElementById("speechAudio");
	// 	if (audioElement) {
	// 		audioElement.pause();
	// 		audioElement.currentTime = 0;
	// 	}
	// 	if (videoRef.current) {
	// 		videoRef.current.pause();
	// 		videoRef.current.currentTime = 0;
	// 	}

	// 	setSpeechClicked(false);
	// 	setSpeechEnabled(false);
	// 	setIsPlaying(false);
	// }, [currentPage]);

	useEffect(() => {
		if (audioRef.current) {
			audioRef.current.pause();
			audioRef.current.currentTime = 0;
		}
		if (videoRef.current) {
			videoRef.current.pause();
			videoRef.current.currentTime = 0;
		}
	
		setSpeechClicked(false);
		setSpeechEnabled(false);
		setIsPlaying(false);
	}, [currentPage]);

	return (
		<>
			<AnimationSpinner show={loading} />
			{modalActive && (
				<div
					className="history-image-model social shadow rounded position-absolute"
					ref={modalRef}
					onClick={handleModelCloseClick}
				>
					<motion.div
						className="model-body position-relative"
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: 20 }}
						transition={{ duration: 0.3 }}
					>
						<main
							className="d-flex justify-content-center align-items-center"
							style={{ width: "600px" }}
						>
							<div
								className="container-fluid p-4"
								style={{
									backgroundColor: "rgb(245, 248, 251)",
									maxWidth: "800px",
									borderRadius: "8px",
								}}
							>
								<div className="row row-cols-1 row-cols-md-3 g-3">
									{socialPlatforms.map((platform) => (
										<div className="col" key={platform.name}>
											<button
												onClick={() => handleShare(platform.link)}
												className="btn d-flex align-items-center w-100 text-white"
												style={{
													backgroundColor: platform.color,
													border: "none",
													padding: "8px 12px",
												}}
											>
												<span className="me-2" style={{ fontSize: "1.2rem" }}>
													{platform.icon}
												</span>
												<span className="small fw-medium">{platform.name}</span>
											</button>
										</div>
									))}
								</div>
							</div>
						</main>
					</motion.div>
				</div>
			)}

			<div
				className="d-flex flex-column justify-content-center align-items-center"
				style={{
					height: "100vh",
					width: "100vw",
					backgroundColor: "rgb(255 55 200 / 10%)",
				}}
			>
				<div
					ref={hiddenDivRef}
					style={{
						visibility: "hidden",
						position: "absolute",
						top: "-9999px",
						width: "400px",
					}}
				></div>

				{!bookPreview && (
					<div className="bookPreview_Error">
						<ErrorComponent
							image={EmptyIcon}
							description={"No book Preview available in page."}
						/>
					</div>
				)}

				{dataFetched && bookPreview && (
					<HTMLFlipBook
						width={400}
						height={500}
						showCover={true}
						mobileScrollSupport={true}
						maxShadowOpacity={0.5}
						onFlip={handleFlip}
						ref={flipBookRef}
						clickEventForward={false}
						useMouseEvents={true}
					>
						<FrontPage
							coverImage={fetchedBookData?.cover_image}
							title={fetchedBookData?.title}
						/>

						{newIndexItems.map((page, index) => (
							<IndexTemplate
								key={index}
								indexItems={page}
								index_page={Number(indexPage.id)}
							/>
						))}

						{newIndexItems.length % 2 == 0 ? (
							<div className="page"></div>
						) : (
							<></>
						)}

						{bookChapter.map((chapter, chapterIndex) => {
							const filteredPages = bookPages.filter(
								(page) => page.book_content_ids === chapter.ids
							);

							return filteredPages.map((page, pageIndex) => {
								const pageTitle = chapter.chapter_title;

								return (
									<Page
										key={`${pageIndex + 1}`}
										number={pageIndex + 1}
										title={pageTitle}
										isLeftPage={page.isLeftPage}
									>
										{page.content}
									</Page>
								);
							});
						})}
					</HTMLFlipBook>
				)}

				{/* {bookPreview && (
					<div className="Pagination_Arrow" style={{ marginTop: "20px" }}>
						<button
							className="prev-btn"
							style={{ display: currentPage == 0 ? "none" : "" }}
							onClick={goPrev}
						>
							<FaArrowLeft />
						</button>

						<button
							className="next-btn"
							style={{
								display:
									currentRenderedPage.current == bookPages.length ? "none" : "",
							}}
							onClick={goNext}
						>
							<FaArrowRight />
						</button>
					</div>
				)} */}

				{currentRenderedPage.current >= 0 &&
					Number(fetchedBookData.enable_book_audio) == 1 &&
					Number(fetchedBookData.enable_avatar) == 0 && (
						<div className="control_tools">
							<div
								className="d-flex justify-content-center align-items-center speech-icon bg-red p-2"
								style={{
									position: "absolute",
									top: "100%",
									left: "50%",
									zIndex: "100",
									transform: "translate(-50%, 20%)",
								}}
							>
								{speechEnabled ? (
									<div className="d-flex">
										<GiSpeakerOff
											onClick={(e) => handleSpeechClick(e, "stop_speech")}
											size={20}
											className="me-2 cursor-pointer hover_enable"
										/>
										{isPlaying ? (
											<AiOutlinePause
												onClick={(e) => handleSpeechClick(e, "pause_speech")}
												size={20}
												className="cursor-pointer"
											/>
										) : (
											<AiOutlinePlayCircle
												onClick={(e) => handleSpeechClick(e, "resume_speech")}
												size={20}
												className="cursor-pointer"
											/>
										)}
									</div>
								) : (
									<BsFillVolumeUpFill
										onClick={(e) => handleSpeechClick(e, "start_speech")}
										size={20}
										className="cursor-pointer"
									/>
								)}
							</div>
						</div>
					)}

				<div
					className={`bottom-nav d-flex align-items-center justify-content-between  ${isOpen ? "" : "	"
						}`}
				>
					{/* <div className="col-lg-4">
						<div className={`site-logo_ ${isOpen ? "d-none" : ""}`}>
							<a href="" target="_blank">
								<img
									src={SmallLogo}
									className="img"
									alt="Logo"
									width={200}
									height={40}
								/>
							</a>
						</div>
					</div> */}
					{bookPreview && (
						<div className="col-lg-10">
							<div
								className={`footer-page-title text-right d-flex align-items-center justify-content-center gap-2`}
							>
								<h4
									className="title mb-0"
									style={{
										fontSize: "18px",
										color: "currentcolor",
										fontWeight: "600",
									}}
								>
									{fetchedBookData.title ?? "Loading..."}
								</h4>
							</div>
						</div>
					)}
					{bookPreview && (
						<div className="col-lg-2 text-end">
							<button
								onClick={() => setModalActive(true)}
								className="action-btn shadow-lg rounded border border-1 border-black-200 p-2 px-3 btn-outline-none preview-share-btn"
							>
								<FaShareSquare size={18} />
							</button>
						</div>
					)}
				</div>
				{bookPreview &&
					Number(fetchedBookData.enable_book_audio) == 1 &&
					Number(fetchedBookData.enable_avatar) == 1 && (
						<div className="live-preview-container">
							<img
								src="https://appstudioo.com/assets/backend/images/iphone12pro1.png"
								alt="I phone"
								className="mockup-bg"
							/>
							<div className="iframe-container">
								<div className="user-avatar">
									{avatarVideo ? (
										<video
											className="aiTalk"
											id="aiTalkVideo"
											muted={true}
											loop={true}
											ref={videoRef}
											preload="auto"
										// style={{ display: speechEnabled ? "block" : "none" }}
										>
											<source src={avatarVideo} type="video/mp4" />
										</video>
									) : (
										<img
											className="aiTalk"
											style={{ display: speechEnabled ? "none" : "block" }}
											id="aiTalkImage"
											src={avatarImage}
										/>
									)}

									{currentRenderedPage.current >= 0 &&
										Number(fetchedBookData.enable_book_audio) == 1 &&
										Number(fetchedBookData.enable_avatar) == 1 && (
											<div
												className="d-flex justify-content-center align-items-center speech-icon bg-red p-2"
												style={{
													position: "absolute",
													top: "100%",
													left: "50%",
													zIndex: "100",
													transform: "translate(-50%, 20%)",
												}}
											>
												{speechEnabled ? (
													<div className="d-flex">
														<img
															onClick={(e) =>
																handleSpeechClick(e, "stop_speech")
															}
															src={mute}
															alt="Stop Speech"
															width="20"
															height="20"
															className="me-2"
														/>
														{isPlaying ? (
															<img
																onClick={(e) =>
																	handleSpeechClick(e, "pause_speech")
																}
																src={pause}
																alt="Pause Speech"
																width="20"
																height="20"
															/>
														) : (
															<img
																onClick={(e) =>
																	handleSpeechClick(e, "resume_speech")
																}
																src={play}
																alt="Resume Speech"
																width="20"
																height="20"
															/>
														)}
													</div>
												) : (
													<img
														onClick={(e) =>
															handleSpeechClick(e, "start_speech")
														}
														src={speaker}
														alt="Start Speech"
														width="20"
														height="20"
													/>
												)}
											</div>
										)}
								</div>
							</div>
						</div>
					)}
				<audio ref={audioRef} id="speechAudio" style={{ opacity: "0" }} />
			</div>
		</>
	);
};

export default TalkingBookPreview;
